export default __webpack_public_path__ + "images/b692e31502fa0c3b7a950d9b92995763.svg";